import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Tooltip } from '@mui/material';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const PurchaseReturnDetails = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL    
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, permissions, token, logout, branchstate } = useAuth();
    const branchId = 0;


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);


    const [formData, setFormData] = useState([]);
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    useEffect(() => {
        fetchData('PurchaseReturnApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Purchase);
                    setInvoicedeatils(response.response_data.PurchaseDetails);
                }
            })
            .catch((error) => {
                console.error('Error fetching Purchase Return Details:', error);
            });
    }, [id]);


    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '100%', marginTop: '10px' }}>

                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.2em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div className="w-full mb-2 flex">
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> Purchase Return - Details</h6>

                    <Button
                        component={Link}
                        to="/PurchaseReturnIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <ArrowCircleLeftIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> Back To List
                    </Button>

                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full flex flex-wrap" style={{ padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>

                    <div className="w-full pr-4" style={{ marginTop: '-0.15%' }}>
                        <div className="w-full mb-2 flex">

                            <div className="w-4/5 mr-2" style={{ marginTop: '-0.15%' }}>
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    Supplier Name
                                    <span className="text-red-500">*</span>
                                    {/* <span style={{ marginLeft: '10%', color: 'black' }}> Invoice Type : </span> <span style={{ color: 'black', fontSize: '14px', fontWeight: 'bolder' }}>{formData.InvoiceTypeName}</span> */}
                                    <span style={{ fontSize: '12px', fontFamily: 'monospace', marginLeft: '10%', color: 'black' }}> Invoice Type : </span> <span style={{ fontSize: '14px', fontWeight: 'bolder', color: 'black', fontFamily: 'monospace' }}>{formData.InvoiceTypeName}</span>


                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.SupplierName}
                                    type="text"
                                    placeholder="Supplier"
                                    name='Supplier'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    Bill Date
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formatDateForInput(formData.BillDate)}
                                    type="date"
                                    name='BillDate'

                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    Bill Number
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    // value={`${formData.BillPrefix || ''}/${formData.BillNumber || ''}/${formData.FinYear || ''}`}
                                    value={formData.BillNumber}
                                    type="text"
                                    placeholder="Bill Number"
                                    disabled
                                />
                            </div>

                        </div>

                        <div className="w-full mb-2 flex">

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    Amount  <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.Amount}
                                    type="text"
                                    placeholder="Amount"
                                    style={{ textAlign: 'right' }}
                                    name='Amount'
                                    readOnly
                                />
                            </div>
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    Discount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.DiscountAmount}
                                    type="text"
                                    placeholder="Discount"
                                    style={{ textAlign: 'right' }}
                                    name='DiscountAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    Taxable Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.TaxableAmount}
                                    type="text"
                                    placeholder="TaxableAmount"
                                    style={{ textAlign: 'right' }}
                                    name='TaxableAmount'
                                    readOnly
                                />
                            </div>
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    CGST
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.CGSTAmount}
                                    type="text"
                                    placeholder="CGST Amount"
                                    style={{ textAlign: 'right' }}
                                    name='CGSTAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    SGST
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.SGSTAmount}
                                    type="text"
                                    placeholder="SGST Amount"
                                    style={{ textAlign: 'right' }}
                                    name='SGST Amount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    IGST
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.IGSTAmount}
                                    type="text"
                                    placeholder="IGST Amount"
                                    style={{ textAlign: 'right' }}
                                    name='IGSTAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    Discount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.DiscountAmount}
                                    type="text"
                                    placeholder="Discount"
                                    style={{ textAlign: 'right' }}
                                    name='DiscountAmount'
                                />
                            </div>



                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    TCS
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.TCSAmount}
                                    type="text"
                                    placeholder="TCS Amount"
                                    style={{ textAlign: 'right' }}
                                    name='TCSAmount'
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    Freight <span style={{ color: 'darkmagenta' }}>({formData.FreightGSTRate}%)</span> <span style={{ color: 'red' }}>{formData.FreightGSTAmount}</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.FreightAmount}
                                    type="text"
                                    placeholder="Freight"
                                    style={{ textAlign: 'right' }}
                                    name='FreightAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    Packing  <span style={{ color: 'darkmagenta' }}> ({formData.PackingGSTRate}%)</span> <span style={{ color: 'red' }}>{formData.PackingGSTAmount}</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.PackingAmount}
                                    type="text"
                                    placeholder="Packing"
                                    style={{ textAlign: 'right' }}
                                    name='PackingAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    Round Off
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.RoundOff}
                                    type="text"
                                    placeholder="RoundOff"
                                    style={{ textAlign: 'right' }}
                                    name='RoundOff'
                                    readOnly
                                />
                            </div>
                        </div>

                        <div className="w-full mb-4 flex">
                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    Remarks
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.Remarks}
                                    type="text"
                                    placeholder="Enter Remarks"
                                    name='Remarks'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    Total Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.TotalAmount}
                                    type="number"
                                    placeholder="Total Amount"
                                    name='TotalAmount'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>


                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    Paid Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.PaidAmount}
                                    type="number"
                                    placeholder="Paid Amount"
                                    name='PaidAmount'
                                    style={{ textAlign: 'right' }}
                                    max={formData.TotalAmount}
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    Balance Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.BalanceAmount}
                                    type="text"
                                    placeholder="BalanceAmount"
                                    name='BalanceAmount'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                        </div>


                        {/* Purchase Order Table */}
                        <div className="w-full mb-2" style={{ marginTop: '-0.95%', overflow: 'auto' }}>
                            <table
                                className="min-w-full bg-white shadow-md rounded-lg overflow-hidden"
                                style={{
                                    borderCollapse: 'collapse',
                                    border: '1px solid #ddd',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    background: 'linear-gradient(135deg, #F3F7FF, #FFFFFF)',
                                }}
                            >
                                <thead
                                    style={{
                                        backgroundColor: '#003A6B',
                                        color: 'white',
                                        textAlign: 'left',
                                        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',

                                    }}
                                >

                                    <tr>
                                        <th
                                            style={{
                                                fontSize: '13px',
                                                padding: '4px',
                                                borderBottom: '2px solid #E0E0E0',
                                                textAlign: 'left', // Align SL.No to the left
                                                color: 'white',
                                            }}
                                        >
                                            SL.No
                                        </th>
                                        {[
                                            // 'SL.No',
                                            'ITEM',
                                            'QTY',
                                            'R.QTY',
                                            'RATE',
                                            'AMOUNT',
                                            'DIS %',
                                            'DIS ₹',
                                            'TAXABLE',
                                            'GST ₹',
                                            'TOTAL',
                                        ].map((header) => (
                                            <th
                                                key={header}
                                                // style={{
                                                //     fontSize: '12px',
                                                //     padding: '4px',
                                                //     borderBottom: '2px solid #E0E0E0',
                                                //     textAlign: header === 'ITEM' ? 'left' : 'right',
                                                //     color: 'white'
                                                // }}
                                                //>
                                                style={{
                                                    fontSize: '12px',
                                                    padding: '4px',
                                                    borderBottom: '2px solid #E0E0E0',
                                                    textAlign: header === 'ITEM' ? 'left' : 'right',
                                                    color: 'white',
                                                    fontFamily: 'monospace'
                                                }}
                                            >
                                                {header}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>

                                <tbody>
                                    {invoicedeatils.map((item, index) => {


                                        return (
                                            <tr key={index} className="border-b"
                                                // style={{
                                                //     backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                                                //     borderBottom: '1px solid #E0E0E0',
                                                //     transition: 'transform 0.2s ease-in-out',
                                                //     cursor: 'pointer',
                                                // }}
                                                // onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                                // onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                            >

                                                <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '1px', textAlign: 'center', width: '75px' }}>
                                                    {index + 1}
                                                </td>
                                                <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '3px', width: '220px' }}>{item.ItemName}</td>

                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                    <input
                                                        type="number"
                                                        value={item.SaledQuantity}

                                                        className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#D3F1DF', textAlign: 'right' }}
                                                        min="0"
                                                        aria-label={`Order quantity for item ${item.Id}`}
                                                        name="SaledQuantity"
                                                        disabled
                                                    />
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '60px' }}>
                                                    <input
                                                        type="number"
                                                        value={item.Quantity}
                                                        className="w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#F6D6D6', textAlign: 'right' }}
                                                        min="0"
                                                        aria-label={`Order quantity for item ${item.Id}`}
                                                        name='Quantity'
                                                    />
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                    <input
                                                        value={item.Rate || 0}
                                                        className="w-full px-1 py-1 border rounded-md"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#DFF2EB', textAlign: 'right' }}
                                                        type="number"
                                                        name="Rate"
                                                    />
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                    <input
                                                        value={item.Amount || 0}
                                                        className="w-full px-1 py-1 border rounded-md"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                        name="Amount"
                                                        readOnly
                                                    />
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                    <input
                                                        value={item.DiscountPercentage || 0}
                                                        className="w-full px-1 py-1 border rounded-md"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#E9EED9', textAlign: 'right' }}
                                                        type="number"
                                                        name="DiscountPercentage"
                                                        min="0"
                                                        onClick={(e) => e.target.select()}
                                                        readOnly
                                                    />
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                    <input
                                                        value={item.DiscountAmount || 0}
                                                        readOnly
                                                        className="w-full px-1 py-1 border rounded-md"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                    />
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                    <input
                                                        value={item.TaxableAmount || 0}
                                                        className="w-full px-1 py-1 border rounded-md"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                        readOnly
                                                    />
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '80px' }}>
                                                    <input
                                                        value={parseFloat(item.CGSTAmount) + parseFloat(item.SGSTAmount) + parseFloat(item.IGSTAmount)}
                                                        className="px-1 py-1 border rounded-md"
                                                        style={{
                                                            fontSize: '13px',
                                                            fontWeight: 'bold',
                                                            textAlign: 'right',
                                                            width: '70%', // Adjust the width to fit
                                                        }}
                                                        readOnly
                                                    />
                                                    <span style={{ marginLeft: '3px', color: 'darkmagenta', fontSize: '11px', fontWeight: 'bold', }}>
                                                        {item.GSTRate ? parseFloat(item.GSTRate).toString() : 0}%
                                                    </span>
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                    <input
                                                        value={item.TotalAmount || 0}
                                                        readOnly
                                                        className="w-full px-1 py-1 border rounded-md"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#EDDFE0', textAlign: 'right' }}
                                                    />
                                                </td>

                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>

            </div >
        </Fragment >

    );
};

export default PurchaseReturnDetails;